export default "__VITE_ASSET__BRklUGkg__"